export default "__VITE_ASSET__c9d921b8__"